import { AfterViewInit, ChangeDetectionStrategy, Component, inject, ViewChild } from '@angular/core';

import { IonSearchbar } from '@ionic/angular';
import { select, Store } from '@ngrx/store';

import { isNull } from 'lodash-es';
import { map, Observable } from 'rxjs';

import { autoCompleteOptions } from '../../../../../../constants/autocomplete.contant';
import { PrimarySubscriptionPlanAccessAliasEnum } from '../../../../../../enums/monetization';
import * as fromWalkingFarmActions from '../../../../../../store/actions/walking-farm.actions';
import * as fromWalkingFarmSelectors from '../../../../../../store/selectors/walking-farm.selectors';
import { MonetizationService } from '../../../../../services/monetization.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-map-search-address',
  standalone: false,
  templateUrl: './map-search-address.component.html'
})
export class MapSearchAddressComponent implements AfterViewInit {
  private monetizationService = inject(MonetizationService);
  private store = inject(Store);

  @ViewChild(IonSearchbar, { read: IonSearchbar, static: false })
  searchBarInput?: IonSearchbar;

  searchText$: Observable<string>;

  constructor() {
    this.searchText$ = this.store.pipe(
      select(fromWalkingFarmSelectors.selectAddressSearchText),
      map((text) => (isNull(text) ? '' : text))
    );
  }

  async ngAfterViewInit() {
    if (this.searchBarInput) {
      const searchInput = await this.searchBarInput.getInputElement();
      const placesAutocomplete = new google.maps.places.Autocomplete(searchInput, autoCompleteOptions);

      placesAutocomplete.addListener('place_changed', async () => {
        const selectedPlace = placesAutocomplete.getPlace();
        if (selectedPlace) {
          const hasAccess = await this.monetizationService.accessFeature([PrimarySubscriptionPlanAccessAliasEnum.A]);
          if (hasAccess) {
            if (selectedPlace.formatted_address) {
              this.store.dispatch(
                fromWalkingFarmActions.geocodeAddressLocation({
                  payload: { address: selectedPlace.formatted_address }
                })
              );
            } else if (selectedPlace.name) {
              this.store.dispatch(
                fromWalkingFarmActions.geocodeAddressLocation({ payload: { address: selectedPlace.name } })
              );
            } else {
              this.store.dispatch(
                fromWalkingFarmActions.geocodeLocationFailure({
                  payload: {
                    error: new Error(
                      `No location data could be found for ${selectedPlace.name ? '"' + selectedPlace.name + '"' : ' your search'}. Please make sure you typed/selected a valid address.`
                    )
                  }
                })
              );
            }
          }
        }
      });
    }
  }

  async searchBarClear() {
    if (this.searchBarInput) {
      const input = await this.searchBarInput.getInputElement();
      input.blur();
      this.store.dispatch(fromWalkingFarmActions.resetSearch());
    }
  }
}
